import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {lastValueFrom, Observable} from 'rxjs';
import {CommonService} from "../services/common.service";
import {HttpClient} from "@angular/common/http";
import {v1URL} from "../constants/urls.constants";
import {roleUrlMap, step} from "../constants/common.constants";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../state/app.state";
import {SetProfile} from "../core/shared.actions";
import {
  StartRegistrationLoading,
  StopRegistrationLoading
} from "../../authentication/core/authentication.actions";

@Injectable({
  providedIn: 'root'
})
export class RegisterStepFourGuard {
  constructor(
    private router: Router,
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private http?: HttpClient,
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree> {
    let response: any;

    const url = v1URL.user.registration['onboarding-step'].url;
    const method = v1URL.user.registration['onboarding-step'].method;

    const removeOnboardingTokens = () => {
      this.commonService.removeRegisterToken();
      this.commonService.removeRegisterOtpToken();
      this.commonService.removeOnboardingToken();
    }
    this.store.dispatch(StartRegistrationLoading());
    response = await lastValueFrom(this.http[method](url));

    const onGoingStep = response.data.onGoingStep;
    if (response.data) {
      removeOnboardingTokens();
      this.commonService.setOnboardingToken(response.data.token);

      if (onGoingStep === step["step-4"]) {
        this.store.dispatch(StopRegistrationLoading());
        return true;
      }
    }

    if (onGoingStep === step['step-6']) {
      if (response.data.profile) {
        const profile = {
          ...response.data.profile,
          roleName: response.data.profile.role.value,
          role: response.data.profile.role.key,
        }
        this.store.dispatch(SetProfile({profile}));
      }
      if (response.data.token) {
        this.commonService.setAuthenticationToken(response.data.token);
      }
      this.router.navigate([`/${roleUrlMap[response.data.role]}`]);
      this.store.dispatch(StopRegistrationLoading());
      return false;
    }

    if (onGoingStep <= step['step-5'] && onGoingStep >= step['step-1']) {
      this.router.navigate([`auth/register/step-${onGoingStep}`]);
    }

    if (onGoingStep === step['step-warning']) {
      this.router.navigate([`auth/step-warning`])
    }

    this.store.dispatch(StopRegistrationLoading());
    return false;
  }

}
